<template>
  <div>
    <div class="product-window" :class="attr.cartAttr === true ? 'on' : ''">
      <div class="textpic acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="attr.productSelect.image.replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',$t('message.img.goods_img_10'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',$t('message.img.goods_img_50'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',$t('message.img.goods_img_5'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',$t('message.img.goods_img_150'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',$t('message.img.goods_img_25'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',$t('message.img.goods_img_500'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',$t('message.img.goods_img_1500'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',$t('message.img.goods_img_2500'))" class="image" />
        </div>
        <div class="text">
          <div class="line1">{{ attr.productSelect.store_name.replace('Double refund',$t('message.goods.name1'))
            .replace('Cash x2 returns',$t('message.goods.name2'))
            .replace('70 times refund(VIP1)',$t('message.goods.name3'))
            .replace('Cash x 72 returns',$t('message.goods.name4')) }}</div>
          <div class="money font-color-red">
            <span class="num">₫{{ parseInt(attr.productSelect.price)|MoneyFormat }}</span>
            <span class="stock">{{$t('message.detail.inventory')}}: {{ attr.productSelect.stock }}</span>
          </div>
        </div>
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>
      <div class="productWinList">
        <div class="item" v-for="(item, indexw) in attr.productAttr" :key="indexw">
          <div class="title">{{ item.attr_name }}</div>
          <div class="listn acea-row row-middle">
            <div class="itemn" :class="item.index === indexn ? 'on' : ''" v-for="(itemn, indexn) in item.attr_value"
              @click="tapAttr(indexw, indexn)" :key="indexn">
              {{ itemn.attr }}
            </div>
          </div>
        </div>
      </div>
      <div class="cart">
        <div class="cart-left">
          <div class="title">{{$t('message.detail.quantity')}}</div>
          <div class="carnum acea-row row-left">
            <div class="item reduce" :class="attr.productSelect.cart_num <= 1 ? 'on' : ''" @click="CartNumDes">
              -
            </div>
            <!--<div class="item num">{{ attr.productSelect.cart_num }}</div>-->
            <input  class="item num" type="number"  v-model="attr.productSelect.cart_num" value="attr.productSelect.cart_num" >
            <div class="item plus" :class=" attr.productSelect.cart_num >= attr.productSelect.stock ? 'on' : ''"
                    @click="CartNumAdd">+</div>
          </div>
        </div>
        <div class="cart-right">
          <p>{{$t('message.detail.total_price')}}:₫{{(attr.productSelect.price * attr.productSelect.cart_num)|MoneyFormat}}</p>
          <p v-if="gameType==24"> {{$t('message.detail.win_rate')}}:50%</p>
          <p v-if="gameType==28"> {{$t('message.detail.win_rate')}}:{{((attr.productSelect.cart_num/80)*100).toFixed(2)}}%</p>
        </div>
      </div>
      <div class="auto-type" v-if="gameType==28">
        <div class="title">{{$t('message.detail.predict_type')}}</div>
        <div class="type-list">
          <div class="type-item" :class="choose==item?'choose':''" v-for="item in choose_list" v-bind:key="item" @click="chooseType(item)">{{item}}</div>
        </div>

      </div>
    </div>
    <div class="mask" @touchmove.prevent :hidden="attr.cartAttr === false" @click="closeAttr"></div>
  </div>
</template>
<script>
export default {
  name: "ProductWindow",
  props: {
    attr: {
      type: Object,
      default: () => {}
    },
    vipPrice:Number,
    gameType:Number,

  },
  data: function() {
    return {
      choose:'',
      choose_list:['Phong tục','Ngẫu nhiên','To lớn','Nhỏ bé','Mantissa','Diện tích']
      // choose_list:['Custom','Random','Big','Small','mantissa','Area']
      // choose_list:this.$t('message.detail.choose_list')
      // choose_list:'message.detail.choose_list'
    };
  },
  mounted: function() {},
  methods: {

    chooseType(item){
      let that = this
      switch (item) {
        case 'Phong tục':
          that.choose = item
          that.$emit("changeFun", { action: "ChangeCartGameType", value: item });
          break;
        case 'Ngẫu nhiên':
          that.choose = item
          that.$emit("changeFun", { action: "ChangeCartGameType", value: item });
          break;
        case 'To lớn':
          that.choose = item
          that.$emit("changeFun", { action: "ChangeCartGameType", value: item });
          that.$emit("changeFun", { action: "handeParentAdd", value: 40 });
          break;
        case 'Nhỏ bé':
          that.choose = item
          that.$emit("changeFun", { action: "ChangeCartGameType", value: item });
          that.$emit("changeFun", { action: "handeParentAdd", value: 40 });
          break;
        case 'Diện tích':
          that.choose = item
          that.$emit("changeFun", { action: "ChangeCartGameType", value: item });
          that.$emit("changeFun", { action: "handeParentAdd", value: 10 });
          break;
        case 'Mantissa':
          that.choose = item
          that.$emit("changeFun", { action: "handeParentAdd", value: 8 });
          that.$emit("changeFun", { action: "ChangeCartGameType", value: item });
          break;

      }
    },
    closeAttr: function() {
      this.$emit("changeFun", { action: "changeattr", value: false });
    },
    CartNumDes: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: false });
    },
    CartNumAdd: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: 1 });
    },
    tapAttr: function(indexw, indexn) {
      let that = this;
      that.attr.productAttr[indexw].index = indexn;
      let value = that
        .getCheckedValue()
        .sort()
        .join(",");
      that.$emit("changeFun", { action: "ChangeAttr", value: value });
    },
    //获取被选中属性；
    getCheckedValue: function() {
      let productAttr = this.attr.productAttr;
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        for (let j = 0; j < productAttr[i].attr_values.length; j++) {
          if (productAttr[i].index === j) {
            value.push(productAttr[i].attr_values[j]);
          }
        }
      }
      return value;
    }
  }
};
</script>
<style>
  .cart{
    display: flex;
    justify-content: space-between;
  }
  .cart-left{

  }
  .cart-right{
    text-align: right;
    padding-top: 0.42rem;
    box-sizing: border-box;
    color: #f73e46;
  }
  .auto-type{
    margin-top: 0.36rem;
    padding: 0 0.3rem;

  }
  .auto-type .title{
    font-size: 0.3rem;
    color: #999;
    margin-bottom: 12px;
  }
  .auto-type .type-list{
    display: flex;
    justify-content:space-around;

  }
  .auto-type .type-item{
    border: 1px solid #A4A4A4;
    border-radius: 3px;
    padding: 3px 5px;
    color: #666;
  }
  .auto-type .choose{
    color: #00c3f9;
    border-color: #00c3f9;
  }


</style>
